import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

export interface AttendanceRecord {
  CreatedDate: string;
  AttendanceStatus: 'PRESENT' | 'ABSENT' | 'LATE' | 'LEAVE' | 'PARTIAL';
}

export interface AttendanceMonthBody {
  attendancePercentage: number;
  attendanceType: 'PERIOD' | 'DAY';
  attendances: AttendanceRecord[];
}

export interface PeriodAttendance {
  subject: string;
  Attendance: 'PRESENT' | 'ABSENT' | 'LATE';
  staffImage: string;
  staffName: string;
  periodStart: string;
  periodEnd: string;
}

// Attendance calendar — parent mobile app's own endpoints (see
// AttendanceCalendar.js / api.js). Monthly list on mount/month-swipe, plus
// a period-wise breakdown fetched only when a tapped day's status is
// PARTIAL — see the API reference this was built from.
@Injectable({ providedIn: 'root' })
export class ParentAttendanceService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  // attendanceDate: "MM/YYYY"
  getMonthlyAttendance(studentId: string, classId: string, schoolId: string, lang: string, attendanceDate: string, academicId: string) {
    return this.http.get(`${this.base}/get/attendance/list/parent`, {
      params: { studentId, classId, schoolId, lang, attendanceDate, academicId },
      headers: this.authHeaders(),
    });
  }

  // attendanceDate: "YYYYMMDD"
  getPeriodWiseAttendance(studentId: string, classId: string, lang: string, attendanceDate: string, academicId: string) {
    return this.http.get(`${this.base}/period/wise/attendance/list/parent`, {
      params: { studentId, classId, lang, attendanceDate, academicId },
      headers: this.authHeaders(),
    });
  }
}
